// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__4DUgq","primary":"style_primary__6ag5T","secondary":"style_secondary__yJUnd","link":"style_link__AIF3y"};